/**
 * コンテンツ内のh2・h3見出しを検出し、自動で目次を生成する（data属性対応）
 */
export function generateTOC() {
	// js-toc_contentクラスを持つコンテンツがなければ処理を終了
	if (!$('.js-toc_content').length) return;

	const $content = $('.js-toc_content'); // 目次対象となるコンテンツ
	const $headings = $content.find('h2, h3'); // h2とh3を全て取得
	if ($headings.length === 0) return; // 見出しがなければ処理を終了

	/**
	 * 目次を構築する関数
	 * @param {jQuery} $target - 目次を挿入する要素
	 */
	function buildTOC($target) {
		const $toc = $('<nav>').addClass('toc_content'); // 目次全体を囲むnav
		const $title = $('<h2>').addClass('toc_ttl').text('目次'); // 目次タイトル
		const $ol = $('<ol>').addClass('toc_list'); // トップレベルのリスト
		let $lastH2Li = null; // 直前のh2のliを保持（h3をサブリストに入れるため）

		// 取得した見出しごとに目次アイテムを生成
		$headings.each(function (index) {
			const tocId = 'heading' + (index + 1); // 一意のIDを作成
			$(this).attr('data-toc-id', tocId); // 見出しにdata属性を付与

			const tagName = this.tagName.toLowerCase(); // h2かh3を判定
			const $li = $('<li>'); // li要素作成
			const $a = $('<a>').attr('href', '#').text($(this).text()); // リンク作成

			// リンククリック時にスムーススクロール
			$a.on('click', function (e) {
				e.preventDefault();
				const $targetHeading = $content.find(`[data-toc-id="${tocId}"]`);
				if ($targetHeading.length) {
					$('html, body').animate({ scrollTop: $targetHeading.offset().top }, 400);
				}
			});

			$li.append($a); // liにリンクを追加

			if (tagName === 'h2') {
				// h2の場合はトップレベルリストに追加
				$li.addClass('toc_list_item-h2');
				$ol.append($li);
				$lastH2Li = $li; // h3用に保持
			} else if (tagName === 'h3') {
				// h3の場合は直前のh2のサブリストに追加
				$li.addClass('toc_list_item-h3');
				if ($lastH2Li) {
					let $subOl = $lastH2Li.find('.toc_list-sub');
					if ($subOl.length === 0) {
						$subOl = $('<ol>').addClass('toc_list-sub'); // サブリスト作成
						$lastH2Li.append($subOl);
					}
					$subOl.append($li);
				} else {
					// 直前のh2がなければトップレベルに追加
					$ol.append($li);
				}
			}
		});

		$toc.append($title).append($ol); // navにタイトルとリストを追加
		$target.append($toc); // 指定要素に目次を追加
	}

	// 目次を置く指定位置がある場合はそこに挿入
	const $insertPoint = $content.find('[data-toc="insert"]');
	if ($insertPoint.length) {
		buildTOC($insertPoint);
	} else {
		// 無ければ従来通り最初のh2の前に目次を挿入
		const $firstH2 = $content.find('h2').first();
		if ($firstH2.length) {
			const $wrapper = $('<div>').addClass('toc_wrapper'); // 目次をラップするdiv
			buildTOC($wrapper);
			$wrapper.insertBefore($firstH2);
		}
	}
}
